<template>
    <div v-if="Object.keys(courierData).length > 0">
        <v-card class="elevation-6 mt-5" width="400">
            <v-card-title>
                <b>
                    Στοιχεία Διεύθυνσης Φοιτητή
                </b>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
                <v-list-tile>
                    <v-list-tile-content>Οδός:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.address}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Αριθμός:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.addressNumber}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Ταχυδρομικός Κώδικας:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.zipcode}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Περιοχή:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.region}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Περιφερειακή ενότητα:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.regionalUnit.name}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Καλλικρατικός Δήμος:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.kallikratMunicipality.name}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Χώρα:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.courierData.country.name}}</v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-card>

    </div>
</template>

<script>
    export default {
        name: "AddressInfoComponent",
        data() {
            return {
            }
        },
        methods: {

        },
        computed: {
            courierData: function () {
                return this.$store.getters.statementAddress;
            }

        }
    }
</script>

<style scoped>

</style>